export const getAdmin = (state) => state.admin;
export const getPaidJobsUnderReview = (jobs) => jobs.underReview;
export const getJobPromotionalRequests = (jobs) => jobs.promotionalRequests;
export const getUnderReviewFreebiesJobs = (underReviewFreebies) =>
  underReviewFreebies.jobs;
export const getExpiredJobToReview = (jobs) => jobs.expired;
export const getCompanyFeaturedLogoRequestsToReview = (promotions) =>
  promotions.featuredLogos;
export const getUnderReviewCompanyFeaturedLogosFreebies = (
  underReviewFreebies
) => underReviewFreebies.companyFeaturedLogos;
export const getCompanyProfilesForReview = (companies) => companies.underReview;
export const getAccountsRequestedForDelete = (accounts) =>
  accounts.requestedDelete;
export const getQuickApplicationsToReview = (candidates) =>
  candidates.quickApplications;
